module.exports = __webpack_public_path__ + "image/pro_list_img7.png";